// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Floatingy {
  from {
    -webkit-transform: translate(0, 0px);
  }
  65% {
    -webkit-transform: translate(50px, 0);
  }
  to {
    -webkit-transform: translate(0, 0px);
  }
}

@keyframes Floatingx {
  from {
    -webkit-transform: translate(50px, 0px);
  }
  65% {
    -webkit-transform: translate(0, 0);
  }
  to {
    -webkit-transform: translate(50px, 0px);
  }
}
.presentation-page .page-header, .index-page .page-header {
  background: #83c1d8;
}
.presentation-page .rellax-text-container .h1-seo, .index-page .rellax-text-container .h1-seo{
  background: #eaf3ff;
    background: linear-gradient(to bottom, #FFFFFF 35%, #75a6c3 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.presentation-page [data-background-color="dark-blue"], .index-page [data-background-color="dark-blue"] {
    background: #031425;
}
`, "",{"version":3,"sources":["webpack://./src/assets/demo/react-demo.css"],"names":[],"mappings":"AAAA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uCAAuC;EACzC;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;IAGjB,iEAAiE;IACjE,6BAA6B;IAC7B,oCAAoC;AACxC;AACA;IACI,mBAAmB;AACvB","sourcesContent":["@keyframes Floatingy {\n  from {\n    -webkit-transform: translate(0, 0px);\n  }\n  65% {\n    -webkit-transform: translate(50px, 0);\n  }\n  to {\n    -webkit-transform: translate(0, 0px);\n  }\n}\n\n@keyframes Floatingx {\n  from {\n    -webkit-transform: translate(50px, 0px);\n  }\n  65% {\n    -webkit-transform: translate(0, 0);\n  }\n  to {\n    -webkit-transform: translate(50px, 0px);\n  }\n}\n.presentation-page .page-header, .index-page .page-header {\n  background: #83c1d8;\n}\n.presentation-page .rellax-text-container .h1-seo, .index-page .rellax-text-container .h1-seo{\n  background: #eaf3ff;\n    background: -moz-linear-gradient(top, #FFFFFF 35%, #75a6c3 100%);\n    background: -webkit-linear-gradient(top, #FFFFFF 35%, #75a6c3 100%);\n    background: linear-gradient(to bottom, #FFFFFF 35%, #75a6c3 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.presentation-page [data-background-color=\"dark-blue\"], .index-page [data-background-color=\"dark-blue\"] {\n    background: #031425;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
